import { useState } from 'react';
import {
  Box,
  Card,
  Typography,
  Chip,
  Button,
  Stack,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Link } from "react-router-dom";
import { BASE_URL_OPENFORGE } from '../../components/Constants';


export default function PublicProjectCard({ project }) {
  const [expanded, setExpanded] = useState(false);
  const [showAll, setShowAll] = useState(false);


  const isLong = project.short_description?.length > 200;
  const description = expanded
    ? project.short_description
    : project.short_description?.slice(0, 200) +
    (isLong ? '...' : '');

  const categories = project.categories
    ? project.categories.split(',')
    : [];
  return (
    <Card
      sx={{
        borderRadius: 3,
        border: `2px solid '#a7f3d0'`,
        overflow: 'hidden',
        transition: '0.3s',
        position: 'relative',
        '&:hover': {
          boxShadow: '0 20px 40px rgba(16, 185, 129, 0.35)',
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #00675B, #049676)",
          px: 2.5,
          py: 2,
          color: '#fff',
        }}
      >
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <LocalOfferIcon fontSize="small" />
            <Typography fontSize={14}>
              {project.group_name}
            </Typography>
          </Stack>

          {/* <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{
              bgcolor: 'rgba(255,255,255,0.2)',
              px: 1.5,
              py: 0.5,
              borderRadius: 20,
            }}
          >
            <CodeIcon fontSize="small" />
            <Typography fontSize={11}>Public</Typography>
          </Stack> */}
        </Stack>
      </Box>

      {/* BODY */}
      <Box
        sx={{
          p: 3,
          display: 'flex',
          gap: 3,
          flexDirection: { xs: 'column', sm: 'row' },
          minHeight: { sm: 180 }, // 👈 ensures consistent card height
        }}
      >
        {/* LEFT */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >


          {/* DESCRIPTION */}
          <Box sx={{ flex: 1, overflowY: 'auto', pr: 1, mt: 1 }}>
            <Typography fontSize={13} color="text.secondary">
              {description}
            </Typography>

            {isLong && (
              <Button
                onClick={() => setExpanded(!expanded)}
                size="small"
                sx={{
                  mt: 1,
                  px: 0,
                  minWidth: 'auto',
                  color: '#047857',
                }}
              >
                {expanded ? '← Show less' : 'Show more →'}
              </Button>
            )}
          </Box>

          {/* TAGS – FIXED */}
          {categories.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                mt: 1,
              }}
            >
              {(showAll ? categories : categories.slice(0, 4)).map((cat, i) => (
                <Chip
                  key={i}
                  label={cat.trim()}
                  size="small"
                  sx={{
                    bgcolor: '#ecfdf5',
                    color: '#047857',
                    border: '1px solid #a7f3d0',
                    fontSize: 11,
                    height: 26,
                  }}
                />
              ))}

              {categories.length > 4 && (
                <Chip
                  label={showAll ? 'Show less' : `+${categories.length - 4} more`}
                  size="small"
                  clickable
                  onClick={() => setShowAll((p) => !p)}
                  aria-label={showAll ? 'Show less categories' : 'Show more categories'}
                  sx={{
                    bgcolor: '#f3f4f6',
                    color: '#374151',
                    border: '1px solid #d1d5db',
                    fontSize: 11,
                    height: 26,
                    cursor: 'pointer',
                  }}
                />
              )}
            </Box>
          )}

        </Box>

        {/* RIGHT */}
        <Box
          sx={{
            minWidth: 180,
            display: 'flex',
            flexDirection:  {md:'column', sm:'column', xs:'row'},
            justifyContent: 'space-between',
            borderLeft: { sm: '2px solid #f3f4f6' },
            pl: { sm: 3 },
            pt: { xs: 2, sm: 0 },
          }}
        >
          <Chip
            icon={<CalendarMonthIcon />}
            label={new Date(project.creation_date).toLocaleDateString(
              'en-US',
              { day: 'numeric', month: 'short', year: 'numeric' }
            )}
            sx={{
              bgcolor: '#ecfdf5',
              color: '#047857',
              fontSize: 12,
              height: 28,
              /* 👇 MOBILE SPACING FIX */
              mt: { xs: 1.5, sm: 0 },   // top space only on mobile
              mb: { xs: 1, sm: 0 },     // bottom space only on mobile
            }}
          />

          <Button
            component="a"
            href={`${BASE_URL_OPENFORGE}/projects/${project.unix_group_name}`}
            target="_self"   // same tab
            rel="noopener"
            variant="contained"
            sx={{
              bgcolor: '#00675B',
              borderRadius: 2,
              py: 1.2,
              '&:hover': {
                boxShadow: '0 20px 40px rgba(16, 185, 129, 0.35)',
              },
            }}
          >
            View Details →
          </Button>
        </Box>
      </Box>
    </Card>
  );
}
